import FilledInput from '@mui/material/FilledInput';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import React from 'react';
import type { SyntheticInputEvent } from 'react-number-format/types/types';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  denseMargin: {},
  labelRoot: {
    color: theme.palette.text.primary,
  },
  fieldRoot: {
    padding: '24px 8px 8px',
    paddingTop: '24px !important',
    paddingBottom: '8px !important',
    borderRadius: 12,
  },
  input: {
    padding: '8px 6px',
  },
}));

function BoxField({
  label,
  value,
  className,
  placeholder,
  onChange,
  fullWidth,
  InputProps,
  InputLabelProps,
  margin = 'normal',
  ...otherProps
}: {
  label: string;
  value: string;
  className?: string;
  placeholder: string;
  onChange?: React.Dispatch<React.SetStateAction<string>>;
  fullWidth?: boolean;
  InputProps?: object;
  InputLabelProps?: {
    classes: object;
  };
  margin: 'normal' | 'dense' | 'none' | undefined;
  classes?: {
    input: string;
    root: string;
  };
  inputProps?: object;
  id?: string;
}) {
  const { classes, cx } = useStyles();

  const handleChange = (e: SyntheticInputEvent) => onChange?.(e.target.value);

  const dense = margin === 'dense';

  return (
    <FormControl
      variant='filled'
      margin={margin}
      classes={{ root: cx(dense && classes.denseMargin, className) }}
      fullWidth={fullWidth}
    >
      <InputLabel {...InputLabelProps} shrink classes={{ ...InputLabelProps?.classes, root: classes.labelRoot }}>
        {label}
      </InputLabel>

      <FilledInput
        {...otherProps}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        multiline
        classes={{
          ...otherProps?.classes,
          input: cx(classes.input, otherProps?.classes?.input),
          root: cx(classes.fieldRoot, otherProps?.classes?.root),
        }}
      />
    </FormControl>
  );
}

export default BoxField;
